import type { TypographyProps } from '@mui/material';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Title = styled((props: TypographyProps) => {
  return <Typography variant="h1" {...props} />;
})(() => ({
  fontWeight: 500,
  textAlign: 'center',
  lineHeight: '2.625rem',
}));
